/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as TrashRouteImport } from './routes/trash'
import { Route as StorageRouteImport } from './routes/storage'
import { Route as SharedWithMeRouteImport } from './routes/shared-with-me'
import { Route as SharedByMeRouteImport } from './routes/shared-by-me'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SearchRouteImport } from './routes/search'
import { Route as ResetRequestRouteImport } from './routes/reset-request'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ViewFileIdRouteImport } from './routes/view.$fileId'
import { Route as LoginFlowTokenRouteImport } from './routes/login-flow.$token'
import { Route as LinksTokenRouteImport } from './routes/links.$token'
import { Route as FolderFolderIdRouteImport } from './routes/folder.$folderId'
import { Route as EditFileIdRouteImport } from './routes/edit.$fileId'
import { Route as CommentsFileIdRouteImport } from './routes/comments.$fileId'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const TrashRoute = TrashRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => rootRouteImport,
} as any)
const StorageRoute = StorageRouteImport.update({
  id: '/storage',
  path: '/storage',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedWithMeRoute = SharedWithMeRouteImport.update({
  id: '/shared-with-me',
  path: '/shared-with-me',
  getParentRoute: () => rootRouteImport,
} as any)
const SharedByMeRoute = SharedByMeRouteImport.update({
  id: '/shared-by-me',
  path: '/shared-by-me',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRequestRoute = ResetRequestRouteImport.update({
  id: '/reset-request',
  path: '/reset-request',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityRoute = ActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewFileIdRoute = ViewFileIdRouteImport.update({
  id: '/view/$fileId',
  path: '/view/$fileId',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginFlowTokenRoute = LoginFlowTokenRouteImport.update({
  id: '/login-flow/$token',
  path: '/login-flow/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LinksTokenRoute = LinksTokenRouteImport.update({
  id: '/links/$token',
  path: '/links/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const FolderFolderIdRoute = FolderFolderIdRouteImport.update({
  id: '/folder/$folderId',
  path: '/folder/$folderId',
  getParentRoute: () => rootRouteImport,
} as any)
const EditFileIdRoute = EditFileIdRouteImport.update({
  id: '/edit/$fileId',
  path: '/edit/$fileId',
  getParentRoute: () => rootRouteImport,
} as any)
const CommentsFileIdRoute = CommentsFileIdRouteImport.update({
  id: '/comments/$fileId',
  path: '/comments/$fileId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/reset-request': typeof ResetRequestRoute
  '/search': typeof SearchRoute
  '/security': typeof SecurityRoute
  '/shared-by-me': typeof SharedByMeRoute
  '/shared-with-me': typeof SharedWithMeRoute
  '/storage': typeof StorageRoute
  '/trash': typeof TrashRoute
  '/verify': typeof VerifyRoute
  '/comments/$fileId': typeof CommentsFileIdRoute
  '/edit/$fileId': typeof EditFileIdRoute
  '/folder/$folderId': typeof FolderFolderIdRoute
  '/links/$token': typeof LinksTokenRoute
  '/login-flow/$token': typeof LoginFlowTokenRoute
  '/view/$fileId': typeof ViewFileIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/reset-request': typeof ResetRequestRoute
  '/search': typeof SearchRoute
  '/security': typeof SecurityRoute
  '/shared-by-me': typeof SharedByMeRoute
  '/shared-with-me': typeof SharedWithMeRoute
  '/storage': typeof StorageRoute
  '/trash': typeof TrashRoute
  '/verify': typeof VerifyRoute
  '/comments/$fileId': typeof CommentsFileIdRoute
  '/edit/$fileId': typeof EditFileIdRoute
  '/folder/$folderId': typeof FolderFolderIdRoute
  '/links/$token': typeof LinksTokenRoute
  '/login-flow/$token': typeof LoginFlowTokenRoute
  '/view/$fileId': typeof ViewFileIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/activity': typeof ActivityRoute
  '/admin': typeof AdminRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/reset': typeof ResetRoute
  '/reset-request': typeof ResetRequestRoute
  '/search': typeof SearchRoute
  '/security': typeof SecurityRoute
  '/shared-by-me': typeof SharedByMeRoute
  '/shared-with-me': typeof SharedWithMeRoute
  '/storage': typeof StorageRoute
  '/trash': typeof TrashRoute
  '/verify': typeof VerifyRoute
  '/comments/$fileId': typeof CommentsFileIdRoute
  '/edit/$fileId': typeof EditFileIdRoute
  '/folder/$folderId': typeof FolderFolderIdRoute
  '/links/$token': typeof LinksTokenRoute
  '/login-flow/$token': typeof LoginFlowTokenRoute
  '/view/$fileId': typeof ViewFileIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activity'
    | '/admin'
    | '/login'
    | '/register'
    | '/reset'
    | '/reset-request'
    | '/search'
    | '/security'
    | '/shared-by-me'
    | '/shared-with-me'
    | '/storage'
    | '/trash'
    | '/verify'
    | '/comments/$fileId'
    | '/edit/$fileId'
    | '/folder/$folderId'
    | '/links/$token'
    | '/login-flow/$token'
    | '/view/$fileId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activity'
    | '/admin'
    | '/login'
    | '/register'
    | '/reset'
    | '/reset-request'
    | '/search'
    | '/security'
    | '/shared-by-me'
    | '/shared-with-me'
    | '/storage'
    | '/trash'
    | '/verify'
    | '/comments/$fileId'
    | '/edit/$fileId'
    | '/folder/$folderId'
    | '/links/$token'
    | '/login-flow/$token'
    | '/view/$fileId'
  id:
    | '__root__'
    | '/'
    | '/activity'
    | '/admin'
    | '/login'
    | '/register'
    | '/reset'
    | '/reset-request'
    | '/search'
    | '/security'
    | '/shared-by-me'
    | '/shared-with-me'
    | '/storage'
    | '/trash'
    | '/verify'
    | '/comments/$fileId'
    | '/edit/$fileId'
    | '/folder/$folderId'
    | '/links/$token'
    | '/login-flow/$token'
    | '/view/$fileId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ActivityRoute: typeof ActivityRoute
  AdminRoute: typeof AdminRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ResetRoute: typeof ResetRoute
  ResetRequestRoute: typeof ResetRequestRoute
  SearchRoute: typeof SearchRoute
  SecurityRoute: typeof SecurityRoute
  SharedByMeRoute: typeof SharedByMeRoute
  SharedWithMeRoute: typeof SharedWithMeRoute
  StorageRoute: typeof StorageRoute
  TrashRoute: typeof TrashRoute
  VerifyRoute: typeof VerifyRoute
  CommentsFileIdRoute: typeof CommentsFileIdRoute
  EditFileIdRoute: typeof EditFileIdRoute
  FolderFolderIdRoute: typeof FolderFolderIdRoute
  LinksTokenRoute: typeof LinksTokenRoute
  LoginFlowTokenRoute: typeof LoginFlowTokenRoute
  ViewFileIdRoute: typeof ViewFileIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trash': {
      id: '/trash'
      path: '/trash'
      fullPath: '/trash'
      preLoaderRoute: typeof TrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage': {
      id: '/storage'
      path: '/storage'
      fullPath: '/storage'
      preLoaderRoute: typeof StorageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared-with-me': {
      id: '/shared-with-me'
      path: '/shared-with-me'
      fullPath: '/shared-with-me'
      preLoaderRoute: typeof SharedWithMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shared-by-me': {
      id: '/shared-by-me'
      path: '/shared-by-me'
      fullPath: '/shared-by-me'
      preLoaderRoute: typeof SharedByMeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-request': {
      id: '/reset-request'
      path: '/reset-request'
      fullPath: '/reset-request'
      preLoaderRoute: typeof ResetRequestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity': {
      id: '/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof ActivityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/view/$fileId': {
      id: '/view/$fileId'
      path: '/view/$fileId'
      fullPath: '/view/$fileId'
      preLoaderRoute: typeof ViewFileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login-flow/$token': {
      id: '/login-flow/$token'
      path: '/login-flow/$token'
      fullPath: '/login-flow/$token'
      preLoaderRoute: typeof LoginFlowTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/links/$token': {
      id: '/links/$token'
      path: '/links/$token'
      fullPath: '/links/$token'
      preLoaderRoute: typeof LinksTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/folder/$folderId': {
      id: '/folder/$folderId'
      path: '/folder/$folderId'
      fullPath: '/folder/$folderId'
      preLoaderRoute: typeof FolderFolderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/edit/$fileId': {
      id: '/edit/$fileId'
      path: '/edit/$fileId'
      fullPath: '/edit/$fileId'
      preLoaderRoute: typeof EditFileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comments/$fileId': {
      id: '/comments/$fileId'
      path: '/comments/$fileId'
      fullPath: '/comments/$fileId'
      preLoaderRoute: typeof CommentsFileIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ActivityRoute: ActivityRoute,
  AdminRoute: AdminRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ResetRoute: ResetRoute,
  ResetRequestRoute: ResetRequestRoute,
  SearchRoute: SearchRoute,
  SecurityRoute: SecurityRoute,
  SharedByMeRoute: SharedByMeRoute,
  SharedWithMeRoute: SharedWithMeRoute,
  StorageRoute: StorageRoute,
  TrashRoute: TrashRoute,
  VerifyRoute: VerifyRoute,
  CommentsFileIdRoute: CommentsFileIdRoute,
  EditFileIdRoute: EditFileIdRoute,
  FolderFolderIdRoute: FolderFolderIdRoute,
  LinksTokenRoute: LinksTokenRoute,
  LoginFlowTokenRoute: LoginFlowTokenRoute,
  ViewFileIdRoute: ViewFileIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
